// @flow
import * as React from "react";
import styled from "styled-components";
import { rtl } from "../common/styled-mixins";
import {
  CurrencyFlag,
  BchImage,
  BtcImage,
  EthImage,
  LtcImage,
  SilverImage,
  GoldImage
} from "../common/Flag";

const Flag = styled(CurrencyFlag)`
  flex-grow: 0;
  flex-shrink: 0;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 50%;
  border: 2px solid currentColor;
  z-index: 2;

  &&& {
    width: 22px;
    height: 22px;
  }
`;

const SecondFlag = styled(Flag)`
  position: absolute;
  ${rtl("right", 0)};
  bottom: 0;
  z-index: 1;

  &&& {
    width: 18px;
    height: 18px;
  }
`;

const customFlags = {
  bch: BchImage,
  btc: BtcImage,
  eth: EthImage,
  ltc: LtcImage,
  xag: SilverImage,
  silver: SilverImage,
  xau: GoldImage,
  gold: GoldImage
};

const StockFlags = ({ stock }: { stock: string }) => {
  const currency1 = stock.toLowerCase().substring(0, 3);
  const currency2 = stock.toLowerCase().substring(3);

  if (customFlags[stock]) {
    return <Flag style={{ backgroundImage: `url(${customFlags[stock]})` }} />;
  }

  if (customFlags[currency1]) {
    return (
      <React.Fragment>
        <Flag style={{ backgroundImage: `url(${customFlags[currency1]})` }} />
        <Flag as={SecondFlag} currency={currency2} />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Flag currency={currency1} />
      <Flag as={SecondFlag} currency={currency2} />
    </React.Fragment>
  );
};

export default StockFlags;



// WEBPACK FOOTER //
// ./src/components/SocialTrading/Flags.js